import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_89vkcymc5z: FaireBrandEntity = {
  token: "b_89vkcymc5z",
  type: "brand",
  name: "Tinned Candle",
  avatarUrl:
    "https://cdn.faire.com/fastly/3945d10528086c75adb09509bb03c1b0d294844b36bb0808c0aee04b1a549dba.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1eefc1213803f00ca573088b44d7f66f999d07d3b118773d0b36fe6077147ffb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3945d10528086c75adb09509bb03c1b0d294844b36bb0808c0aee04b1a549dba.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1eefc1213803f00ca573088b44d7f66f999d07d3b118773d0b36fe6077147ffb.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 93,
  isTopShop: true,
  isInsider: true,
  description:
    "Meet Tinned Candle, a unique brand created by an artist in Atlanta, Georgia, fueled by a lifelong passion for tinned fish. But here's the exciting news: we're not stopping at candles. Stay tuned for a wave of new products. We're committed to constantly expanding our catalog for fellow tinned fish enthusiasts!\n\nEach candle is hand-poured in small batches. Picture this: each candle comes in a tin that opens just like a sardine tin, revealing charming tinned food-shaped designs, such as sardines and octopus. \n\nDriven by the artist's passion as an illustrator, Tinned Candle was born to turn this unique concept into a reality. These candles aren't just candles; they're artistic masterpieces. Crafted with meticulous attention to detail, they don't just illuminate spaces – they infuse them with whimsy, nostalgia, and joy.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:22.113Z",
    importedBy: "entity-db-cli",
  },
};
